<template>
    <div class="ui container" style="position: relative; background: #ffffff">
      <h2 class="ui main header">Boot Mieten</h2>
      <div style="float: right">
        <div class="ui dropdown">
          <div class="text"><i class="de flag"></i> Deutsch</div>
          <i class="dropdown icon"></i>
          <div class="menu">
            <div class="item" @click="$i18n.locale = 'de'"><i class="de flag"></i> Deutsch</div>
            <div class="item" @click="$i18n.locale = 'en'"><i class="gb flag"></i> English</div>
          </div>
        </div>
      </div>

      <div class="ui negative message" v-if="bookingDisabled">
        <div class="header">
          Buchung derzeit nicht möglich.
        </div>
      </div>
      <div v-else>
        <div class="ui four large steps">
          <a class="step" :class="[{ active: step == 1 }, { completed: selected.length > 0 }]" @click="step = 1">
            <i class="calendar icon"></i>
            <div class="content">
              <div class="title">{{ $t('Boat & Time') }}</div>
              <div class="description" v-html="$t('Choose your boat and desired date and time')"></div>
            </div>
          </a>
          <a class="step"
             :class="[{ active: step == 2 }, { completed: detailsFormValid }, { disabled: selected.length == 0 }]"
             @click="step = 2">
            <i class="list icon"></i>
            <div class="content">
              <div class="title">{{ $t('Details & Extras') }}</div>
              <div class="description" v-html="$t('Enter additional wishes')"></div>
            </div>
          </a>
          <a class="step"
             :class="[{ active: step == 3 }, { completed: formValid }, { disabled: !detailsFormValid || selected.length == 0  }]"
             @click="step = 3">
            <i class="user icon"></i>
            <div class="content">
              <div class="title">{{ $t('Contact Details') }}</div>
              <div class="description">{{ $t('Enter contact details') }}</div>
            </div>
          </a>
          <a class="step"
             :class="[{ active: step == 4 }, { completed: step > 4 }, { disabled: !formValid || selected.length == 0 }]"
             @click="step = 4">
            <i class="info icon"></i>
            <div class="content">
              <div class="title">{{ $t('Review & Confirm') }}</div>
              <div class="description">{{ $t('Confirm your booking') }}</div>
            </div>
          </a>
        </div>
        <div style="position: fixed; right: 20px; bottom: 20px; z-index: 10">
          <button class="ui big primary button" :class="{'disabled': !canContinue}" v-if="step == 1"
                  @click="step = step + 1">
            <span v-if="canContinue">{{ $t('Accept & Continue') }}</span>
            <span v-else>{{ $t('Select slots to continue') }}</span>
            <i class="right arrow icon"></i>
          </button>
          <button class="ui big icon primary button" :class="{ 'disabled': !canContinue }" v-if="step == 2"
                  @click="goToContactDetails">
            <span>{{ $t('Accept & Continue') }}</span>
            <i class="right arrow icon"></i>
          </button>
          <button class="ui big icon primary button" :class="{ 'disabled': !canContinue }" v-if="step == 3"
                  @click="goToConfirm">
            <span>{{ $t('Go To Confirmation') }}</span>
            <i class="right arrow icon"></i>
          </button>
          <button class="ui big icon primary button" v-if="step == 4" @click="confirmBooking">
            <span>{{ $t('Confirm Booking') }}</span>
            <i class="checkmark icon"></i>
          </button>
        </div>
        <div style="position: fixed; left: 20px; bottom: 20px; z-index: 10" v-if="canBack">
          <button class="ui negative big button" @click="step = step - 1">
            <i class="left arrow icon"></i>
            {{ $t('Back') }}
          </button>
        </div>

        <transition @beforeEnter="beforeAnimationEnter" @beforeLeave="beforeAnimationLeave">
          <div v-if="step == 1" key="step1" style="position: absolute; width: 100%">
            <div class="ui huge menu">
              <div class="item" style="font-weight: 300">
                {{ $t('Selected date') }}:
              </div>
              <a href="#" class="item" @click.prevent="dateMinus"><i class="icon arrow left"></i></a>
              <div class="calendar item">
                <div class="ui basic calendar">
                  <div class="ui huge icon input">
                    <i class="calendar icon"></i>
                    <input type="text" name="date" placeholder="Datum">
                  </div>
                </div>
              </div>
              <a href="#" class="item" @click.prevent="datePlus"><i class="icon arrow right"></i></a>
              <div class="right menu"></div>
              <div class="item" v-if="selected.length > 0">
                {{ $t('Price for selected') }}:
                <div class="ui large blue basic label"><strong>€{{selectedPrice}}</strong></div>
              </div>
              <!--<a class="small red item" @click="triggerCancelModal" v-else>-->
              <!--<strong><i class="edit icon"></i> {{ $t('Cancel Booking') }}</strong>-->
              <!--</a>-->
            </div>
<!--            <div class="ui raised error message">-->
<!--              <div class="header">-->
<!--                Achtung!-->
<!--              </div>-->
<!--              <p>Wegen der Koronasituation, haben wir...</p>-->
<!--            </div>-->
            <div class="ui blue raised segment" id="segment" style="position: relative; margin-bottom: 20px;">
              <h2 class="ui red header">
                Buchungsbeginn zur vollen Stunde
              </h2>
              <table class="ui definition celled bottom attached table">
                <thead>
                <tr>
                  <th></th>
                  <th v-for="hour in hours" class="center aligned"
                      style="width: 72px"
                      :id="hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)">
                    {{ hour }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="boat in boatsStartFull"
                    :class="{ 'thick-border': boatsStartFull[boatsStartFull.indexOf(boat) - 1] && boat.type !== boatsStartFull[boatsStartFull.indexOf(boat) - 1].type }">
                  <td class="center aligned boat-title"
                      data-tooltip="Click for details and pictures"
                      data-inverted="true"
                      data-variation="mini"
                      @click="showBoatDescription(boat)"
                  >
                    <span class="title">{{ boat.name }}</span><br>
                    <span style="font-weight: 300; font-size: 12px">{{ boat.capacity.min }}-{{ boat.capacity.max }} Pax - {{ boat.price }},-€/Std.</span><br>
                  </td>
                  <booking-choice
                      v-for="hour in hours"
                      :hour="hour"
                      :boat="boat"
                      :key="hour.index"
                      :selected="selected"
                      :date="date"
                      :allBookings="allBookings"
                      :bookingAllowedBefore="settings.bookingAllowedBefore"
                      :clientId="clientId"
                      :updatedBooking="updatedBooking"
                      @selected="selected">
                  </booking-choice>
                </tr>
                </tbody>
              </table>
              <div
                  class="ruler"
                  :style="{ width: '2px', height: '100%', position: 'absolute', backgroundColor: 'red', top: '0px', left: ruler.left }"
                  v-if="ruler.visible">
              <span>
                {{ $t('NOW') }}
              </span>
              </div>
            </div>
            <div class="ui orange raised segment" id="segment2" style="position: relative; margin-bottom: 80px;">
              <h2 class="ui red header">
                Buchungsbeginn zur halben Stunde
              </h2>
              <table class="ui definition celled bottom attached table" style="width: auto">
                <thead>
                <tr>
                  <th style="width: 125px !important"></th>
                  <th v-for="hour in hours" class="center aligned"
                      style="width: 72px !important"
                      :id="hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)">
                    {{ (parseInt(hour.split(' - ')[0]) - 1) + ':30' }}<br>-<br>{{ (parseInt(hour.split(' - ')[1]) - 1) + ':30' }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="boat in boatsStartHalf"
                    :class="{ 'thick-border': boatsStartHalf[boatsStartHalf.indexOf(boat) - 1] && boat.type !== boatsStartHalf[boatsStartHalf.indexOf(boat) - 1].type }">
                  <td class="center aligned boat-title"
                      data-tooltip="Click for details and pictures"
                      data-inverted="true"
                      data-variation="mini"
                      @click="showBoatDescription(boat)"
                  >
                    <div class="title" style="width: 110px">{{ boat.name }}</div>
                    <span style="font-weight: 300; font-size: 12px">{{ boat.capacity.min }}-{{ boat.capacity.max }} Pax - {{ boat.price }},-€/Std.</span><br>
                  </td>
                  <booking-choice
                    v-for="hour in hours"
                    :hour="hour"
                    :boat="boat"
                    :key="hour.index"
                    :selected="selected"
                    :date="date"
                    :allBookings="allBookings"
                    :bookingAllowedBefore="settings.bookingAllowedBefore"
                    :clientId="clientId"
                    :updatedBooking="updatedBooking"
                    @selected="selected">
                  </booking-choice>
                </tr>
                </tbody>
              </table>
              <div
                class="ruler"
                :style="{ width: '2px', height: '100%', position: 'absolute', backgroundColor: 'red', top: '0px', left: ruler.left }"
                v-if="ruler.visible">
              <span>
                {{ $t('NOW') }}
              </span>
              </div>
            </div>
          </div>
          <div v-if="step == 2" key="step2">
            <div class="ui blue raised segments" style="position: absolute; margin-bottom: 80px; width: 100%">
              <div class="ui segment">
                <h4 style="font-weight: 300">{{ $t('ADDITIONAL DETAILS') }}</h4>
              </div>
              <div class="ui very padded segment">
                <form class="ui details large form" @submit.prevent>
                  <div class="ui relaxed grid">
                    <div class="ui row">
                      <div class="ui eight wide column">
                        <div class="field">
                          <label>{{ $t('How many guests will be on the boat(s)?') }}</label>
                          <input type="number" name="numPeople" min="1" step="1" v-model="details.numPeople"
                                 style="width: 150px" placeholder="Enter number">
                        </div>
                      </div>
                    </div>
                    <div class="ui row">
                      <div class="ui eight wide column">
                        <div class="field">
                          <label>{{ $t('What\'s the reason for booking our boats?') }}</label>
                          <select class="ui selection dropdown" name="reason" v-model="details._reason">
                            <option value="">Select</option>
                            <option :value="reason._id" v-for="reason in reasons">{{ reason.title }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="ui row">
                      <div class="ui sixteen wide column">
                        <div class="field">
                          <label>{{ $t('Do you require additional services?') }}</label>
                        </div>

                        <div class="service list item" v-for="additionalService in additionalServices">
                          <div class="select">
                            <div class="ui basic tiny buttons">
                              <div class="ui button" @click="toggleService(additionalService)"
                                   v-if="!additionalService.selected"><i class="checkmark icon"></i> Select
                              </div>
                              <div class="ui button" @click="toggleService(additionalService)" v-else><i
                                  class="delete icon"></i> Remove
                              </div>
                            </div>
                          </div>
                          <div class="content">
                            {{ additionalService.title }}
                            <br>
                            <span style="font-size: 12px">
                            {{ additionalService.description }}
                          </span>
                            <br v-if="additionalService.letter === 'V'">
                            <img src="../assets/SNX3.jpg" style="height: 80px" v-if="additionalService.letter === 'V'">
                          </div>
                          <div class="price">
                            <span :class="{ 'strong': additionalService.selected }">€ {{ numeral(additionalService.price).format('0,0.00') }}<span
                                v-if="additionalService.priceType === 'perPerson'"> / person</span></span>
                          </div>
                          <div class="icon">
                            <i class="large green checkmark icon"
                               :class="{'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected}"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ui row">
                      <div class="ui eight wide column">
                        <div class="field">
                          <label>{{ $t('Do you have any additional wishes?') }}</label>
                          <textarea name="wishes" v-model="details.wishes" rows="4" placeholder=""></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="ui row">
                      <div class="ui eight wide column">
                        <div class="field">
                          <label>{{ $t('Do you have any additional questions?') }}</label>
                          <textarea name="questions" v-model="details.questions" rows="4" placeholder=""></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="ui row">
                      <div class="ui eight wide column">
                        <div class="field">
                          <label>{{ $t('Do you have a voucher code?') }}</label>
                          <div class="ui right icon input">
                            <input type="text" name="voucher" v-model="details.voucher" style="width: 250px"
                                   placeholder="">
                            <i class="barcode icon"></i>
                          </div>

                        </div>
                        <div class="ui positive message" v-if="voucher">
                          <div class="header">
                            {{ $t('Congratulations! You are eligible for discount.') }}
                          </div>
                          <p>A discount of
                            <strong>
                              <span v-if="voucher.deduct.percentage > 0">-{{ voucher.deduct.percentage * 100}}%</span>
                              <span v-if="voucher.deduct.percentage > 0 && voucher.deduct.absolute > 0"> and </span>
                              <span v-if="voucher.deduct.absolute > 0">-{{ voucher.deduct.absolute }}.00€</span>
                            </strong>
                            is applied to this booking.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="step == 3" key="step3">
            <div class="ui blue raised segments" style="position: absolute; margin-bottom: 80px; width: 100%">
              <div class="ui segment">
                <h4 style="font-weight: 300">{{ $t('YOUR CONTACT DETAILS') }}</h4>
              </div>
              <div class="ui padded segment">
                <form class="ui contact-details form" v-on:submit.prevent="confirmBooking">
                  <div class="ui relaxed grid">
                    <div class="seven wide column">
                      <div class="ui error message"></div>
                      <div class="required field">
                        <!--<label>Title</label>-->
                        <select class="ui selection dropdown" v-model="contact.title">
                          <option value="">{{ $t('Mr or Mrs') }}</option>
                          <option value="Herr">{{ $t('Mr') }}</option>
                          <option value="Frau">{{ $t('Mrs') }}</option>
                        </select>
                      </div>
                      <div class="field">
                        <label>{{ $t('Title') }}</label>
                        <select class="ui selection dropdown" name="title" v-model="contact.title">
                          <option value="">{{ $t('Select') }}</option>
                          <option value="Dr">{{ $t('Dr') }}</option>
                          <option value="Prof">{{ $t('Prof') }}</option>
                          <option value="Mag">{{ $t('Mag') }}</option>
                        </select>
                      </div>
                      <div class="two fields">
                        <div class="required field">
                          <label>{{ $t('First Name') }}</label>
                          <input type="text" name="firstName" v-model="contact.firstName">
                        </div>
                        <div class="required field">
                          <label>{{ $t('Last Name') }}</label>
                          <input type="text" name="lastName" v-model="contact.lastName">
                        </div>
                      </div>
                      <div class="field">
                        <label>{{ $t('Company') }}</label>
                        <input type="text" name="company" v-model="contact.company">
                      </div>
                      <div class="required field">
                        <label>{{ $t('Email') }}</label>
                        <input type="text" name="email" v-model="contact.email">
                      </div>
                      <div class="required field">
                        <label>{{ $t('Telephone') }}</label>
                        <input type="text" name="tel" v-model="contact.tel">
                      </div>
                      <div class="field">
                        <label>{{ $t('Address') }}</label>
                        <input type="text" name="address" v-model="contact.address">
                      </div>
                      <div class="fields">
                        <div class="ten wide field">
                          <label>{{ $t('City') }}</label>
                          <input type="text" name="city" v-model="contact.city">
                        </div>
                        <div class="six wide field">
                          <label>{{ $t('Post Code') }}</label>
                          <input type="text" name="zip" v-model="contact.zip">
                        </div>
                      </div>
                      <div class="field">
                        <div class="ui inline checkbox">
                          <input type="checkbox" name="newsletter" v-model="contact.newsletterAccepted">
                          <label>{{ $t('I agree to receive newsletter emails') }}</label>
                        </div>
                      </div>
                      <div class="field">
                        <div class="ui inline checkbox">
                          <input type="checkbox" name="photos" v-model="contact.photosAccepted">
                          <label>{{ $t('I agree that my photos can be used for Meine Insel promotion') }}</label>
                        </div>
                      </div>
                      <div class="field">
                        <div class="ui inline checkbox">
                          <input type="checkbox" name="terms" v-model="contact.termsAccepted">
                          <label>{{ $t('I accept the') }} <a href="https://www.meine-insel.at/agb" target="_blank">{{
                            $t('Terms of Service') }}</a></label>
                        </div>
                      </div>
                    </div>
                    <div class="ui nine wide column">
                      <div class="ui styled fluid accordion">
                        <div class="title active">
                          <i class="dropdown icon"></i>
                          Was passiert bei Schlechtwetter?
                        </div>
                        <div class="content active">
                          <p>
                            Definition: Als Schlechtwetter gilt... <br> 1. Wirklicher Niederschlag (Regen)<br>2. Sturm
                            (Mehr als Beaufort 5)<br>3. Temperaturen unter 16 Grad Celsius
                          </p>
                          <p>
                            Es gilt die Wettersituation auf der Alten Donau.
                          </p>
                          <p>
                            Da die heurige Saison gezeigt hat, dass "Transdanubien" eine eigene Klimazone hat (z.B. bei
                            Regen am Wienerberg oder in Hietzing trotzdem strahlender Sonnenschein an der Alten Donau),
                            rufen Sie uns im Zweifel bitte ca. 3h vor Antritt der Fahrt an!
                          </p>

                          <p>Wenn es wirklich regnet, gilt die Reservierung automatisch als kostenlos storniert. Sollte
                            es stark bewölkt sein und nur eine Regenwahrscheinlichkeit bestehen, kann gefahren werden.
                            Sollten Sie die Fahrt angetreten haben und der Regen während Ihrer Mietzeit eintreten,
                            zahlen Sie selbstverständlich nur für die tatsächlich gefahrene Zeit.</p>
                        </div>
                        <div class="title">
                          <i class="dropdown icon"></i>
                          Mietzeit
                        </div>
                        <div class="content">
                          <p>Unsere Boote werden stundenweise zur vollen Stunde vermietet.</p>
                          <p>Bei einer Stunde Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,
                            die letzten 5 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 45 Minuten.</p>
                          <p>Bei zwei Stunden Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,
                            die letzten 10 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 100 Minuten.</p>
                          <p>Bei drei Stunden Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,
                            die letzten 10 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 160 Minuten.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="step == 4" key="step4">
            <div class="ui blue raised segment"
                 style="width: 100%; position: absolute; margin-bottom: 80px; padding-top: 50px; padding-bottom: 50px">
              <div class="ui centered grid">
                <div class="ui seven wide column">
                  <h4 style="text-align: center">
                    {{ $t('Please verify your booking and confirm.') }}
                  </h4>


                  <div class="ui top attached segment">
                    <h4>{{ contact.title }} {{ contact.firstName }} {{ contact.lastName }}</h4>
                    <p>
                      <span v-if="contact.company">{{ $t('Company') }}: {{ contact.company }}<br></span>
                      {{ $t('Email') }}: {{ contact.email }}<br>
                      {{ $t('Telephone') }}: {{ contact.tel }}<br>
                      {{ $t('Address') }}: {{ contact.address }}<br>
                      {{ $t('City') }}: {{ contact.city }}, {{ contact.zip }}
                    </p>
                  </div>
                  <table class="ui bottom attached basic table">
                    <tbody>
                    <tr>
                      <td colspan="3">{{ $t('People') }}</td>
                      <td class="right aligned">
                        {{ details.numPeople }}
                      </td>
                    </tr>
                    <tr v-for="booking in selected">
                      <td>
                        {{ booking.boat.name }}
                      </td>
                      <td>
                        <span v-if="booking.boat.startsAtHalfHour">
                          {{ (parseInt(booking.hour.split(' - ')[0]) - 1) + ':30' }} - {{ (parseInt(booking.hour.split(' - ')[1]) - 1) + ':30' }} h
                        </span>
                        <span v-else>
                          {{ booking.hour }} h
                        </span>
                      </td>
                      <td>
                        {{ moment(booking.date).format('ll') }}
                      </td>
                      <td class="right aligned">
                        €{{ booking.cost }}.00
                      </td>
                    </tr>
                    <tr v-if="voucher">
                      <td colspan="4"><strong>Voucher:</strong> {{ voucher.code }}</td>
                    </tr>
                    <tr v-if="voucher && voucher.deduct.absolute > 0">
                      <td colspan="3"></td>
                      <td class="right aligned">- €{{ voucher.deduct.absolute }}.00</td>
                    </tr>
                    <tr v-if="voucher && voucher.deduct.percentage > 0">
                      <td colspan="3"></td>
                      <td class="right aligned">- {{ voucher.deduct.percentage * 100 }}%</td>
                    </tr>
                    </tbody>
                    <!--<tfoot>-->
                    <tr>
                      <td colspan="3"><strong>Total</strong></td>
                      <td class="right aligned">
                        <strong>€{{ selectedPrice }}</strong>
                      </td>
                    </tr>
                    <!--</tfoot>-->
                    <tr v-if="additionalServices.length > 0">
                      <td colspan="4">
                        <strong>{{ $t('Additional Services') }}</strong>
                      </td>
                    </tr>
                    <tr v-for="service in additionalServices" v-if="service.selected">
                      <td colspan="3">
                        {{ service.title }}<!--<span v-if="service.priceType === 'perPerson'">/ pro Person</span>-->
                      </td>
                      <td class="right aligned">
                        <span v-if="service.priceType === 'perPerson'">p.P. €{{ numeral(service.price).format('0,0.00') }}</span>
                        <span v-else>€{{ numeral(service.price).format('0,0.00') }}</span>
                      </td>
                    </tr>
                    <tr v-if="details.wishes">
                      <td colspan="4">
                        <strong>{{ $t('Additional Wishes') }}</strong>
                      </td>
                    </tr>
                    <tr v-if="details.wishes">
                      <td colspan="4">
                        {{ details.wishes }}
                      </td>
                    </tr>
                    <tr v-if="details.questions">
                      <td colspan="4">
                        <strong>{{ $t('Questions') }}</strong>
                      </td>
                    </tr>
                    <tr v-if="details.questions">
                      <td colspan="4">
                        {{ details.questions }}
                      </td>
                    </tr>
                  </table>
                  <!--<div class="ui warning message">
                    <div class="header">
                      IMPORTANT! You have to confirm the booking with the confirmation email
                    </div>
                    <p>Upon clicking the link below, you will receive an email with a confirmation link. Only then the booking is valid!</p>
                  </div>-->
                  <button class="ui big fluid primary button" @click="confirmBooking">
                    <span>{{ $t('Confirm Booking') }}</span>
                    <i class="checkmark icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="ui small basic modal" id="confirmModal">
          <div class="header">
            Booking Confirmed
          </div>
          <div class="content">
            You will be notified by email.
          </div>
          <div class="actions">
            <div class="ui green ok inverted button">
              <i class="checkmark icon"></i>
              Okay
            </div>
          </div>
        </div>

        <div class="ui small basic modal" id="timeoutWarningModal">
          <div class="header">
            Are you there?
          </div>
          <div class="content">
            Your booking session will expire in <strong>{{ settings.sessionTimeoutClear }} seconds</strong>! Press any
            click to continue booking.
          </div>
          <div class="actions">
            <div class="ui inverted icon cancel button">
              <i class="right arrow icon"></i>
              Continue booking
            </div>
          </div>
        </div>

        <div class="ui small basic modal" id="emailConfirmModal">
          <div class="header">
            Booking Confirmed
          </div>
          <div class="content">
            <p>Your booking was confirmed! An email was sent to you with all details and instructions.</p>
            <p>You can print this confirmation</p>

            <booking-confirmation :created-reservation="createdReservation"></booking-confirmation>
          </div>
          <div class="actions">
            <div class="ui inverted icon cancel button">
              <i class="checkmark icon"></i>
              Close
            </div>
            <div class="ui inverted icon button" @click="printConfirmation">
              <i class="print icon"></i>
              Print
            </div>
          </div>
        </div>

        <div class="ui modal" id="boatDescriptionModal">
          <div class="header">
            {{ describeBoat.name }}
          </div>
          <div class="content" v-html="describeBoat.description">
          </div>
          <div class="actions">
            <div class="ui icon cancel button">
              Close
            </div>
          </div>
        </div>


        <cancel-booking></cancel-booking>
      </div>

    </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../services/'
  import app from './../services/index'
  import BookingChoice from './BookingChoice.vue'
  import CancelBooking from './booking/CancelBooking.vue'
  import BookingConfirmation from './booking/BookingConfirmation.vue'
  import '../../bower_components/semantic-ui-calendar/dist/calendar.min'
  import '../../bower_components/semantic-ui-calendar/dist/calendar.min.css'
  import '../../node_modules/vue2-animate/dist/vue2-animate.min.css'
  import _ from 'lodash'
  import printJS from 'print-js'

  export default {
    data() {
      return {
        'step': 1,
        'date': null,
        'allBookings': [],
        'selected': [],
        'contact': {
          'firstName': null,
          'lastName': null,
          'email': null,
          'address': null,
          'city': null,
          'zip': null,
          'tel': null,
          'termsAccepted': false,
          'newsletterAccepted': true,
          'photosAccepted': true,
//          'comments': null,
        },
        'parsedTel': null,
        'details': {
          'numPeople': null,
          'voucher': null,
          'wishes': null,
          'questions': null,
          '_reason': null,
          'reason': null,
          'services': []
        },
        'describeBoat': {
          'name': null,
          'description': null
        },
        'formValid': false,
        'detailsFormValid': false,
        'hours': [
          '10 - 11', '11 - 12', '12 - 13', '13 - 14', '14 - 15', '15 - 16', '16 - 17', '17 - 18', '18 - 19', '19 - 20', '20 - 21', '21 - 22', '22 - 23'
        ],
        'boats': [],
        'clientId': null,
        'moment': moment,
        'numeral': numeral,
        'animation': {
          'enter': 'fadeInRight',
          'leave': 'fadeOutLeft',
          'oldStep': 1
        },
        'voucher': null,
        'createdReservation': {
          'code': null,
          'bookings': [],
          'contact': {},
          'people': 0,
          'cost': null,
          'questions': null,
          'reason': null,
          'services': [],
          'wishes': null
        },
        'settings': {},
        'reasons': [],
        'additionalServices': [],
        'rulerGeometry': {
          'span': 50,
          'leftOffset': 0
        },
        'submitting': false,
        'updatedBooking': null,
        'now': new Date(),
        'bookingDisabled': false
      }
    },
    watch: {
      step: function (newStep, currentStep) {
        this.animation.oldStep = currentStep

        $("html, body").animate({ scrollTop: 0 }, 400)

        if (this.step === 1) {
          setTimeout(() => {
            this.initUiFirstStep()
          }, 100)
        } else if (this.step === 2) {
          setTimeout(() => {
            $('.ui.selection.dropdown').dropdown()

            let uniqueBoats = []
            for (let booking of this.selected) {
              if (!uniqueBoats.find(one => {return one.boat === booking.boat._id})) uniqueBoats.push({'boat': booking.boat._id, 'capacity': booking.boat.capacity.max })
            }
            let maxPeople = uniqueBoats.map(one => {return one.capacity}).reduce((a, b) => {return a + b})

            $('.ui.details.form')
              .form({
                fields: {
                  numPeople: {
                    identifier  : 'numPeople',
                    rules: [
                      {
                        type   : 'empty',
                        prompt : 'Please enter the number of people'
                      },
                      {
                        type   : 'integer[1..' + maxPeople.toString() + ']',
                        prompt : 'Number of people is too low or higher than the capacity of selected boats. <strong>Max: ' + maxPeople.toString() + ' people.</strong>'
                      }
                    ]
                  },
                  reason: {
                    identifier: 'reason',
                    rules: [
                      {
                        type: 'empty',
                      }
                    ]
                  }
                },
                prompt: {
                  empty: 'This field is required',
                  checked: 'You have to accept the Terms of service'
                },
                inline: true,
                on: 'change',
                keyboardShortcuts: false,
                onSuccess: function () {
                  this.detailsFormValid = true
                  this.step = 3
//                  console.log('details form valid')
                }.bind(this),
                onFailure: function () {
                  this.detailsFormValid = false
//                  console.log('details form invalid')
                }.bind(this)
              });

          }, 100)
        } else if (this.step === 3) {
            setTimeout(() => {
              $('.ui.selection.dropdown').dropdown()
              $('.ui.accordion').accordion()
              $('.ui.contact-details.form')
                .form({
                  fields: {
                    firstName : 'empty',
                    lastName  : 'empty',
                    tel : 'empty',
                    email     : ['empty', 'email'],
                    terms     : 'checked'
                  },
                  prompt: {
                    empty: 'This field is required',
                    checked: 'You have to accept the Terms of service'
                  },
                  inline: true,
                  on: 'blur',
                  keyboardShortcuts: false,
//                  debug: true,
                  onSuccess: function () {
                    this.formValid = true
                    this.step = 4
//                    console.log('form valid')
                  }.bind(this),
                  onFailure: function () {
                    this.formValid = false
//                    console.log('form invalid')
                  }.bind(this)
                });

            }, 100)
        }
      },
      'details.voucher': _.debounce(
        function () {
          services.voucherService.find({ query: { code: this.details.voucher, $limit: 1 }}).then(vouchers => {
            if (vouchers.data[0]) this.voucher = vouchers.data[0]
          })
        }, 500
      ),
      'details._reason': function () {
        if (this.details._reason) this.details.reason = this.reasons.find(reason => { return reason._id === this.details._reason })['title']
      },
      'date': _.debounce(function () {
//        this.loading = true
        services.bookingService.find({
          query: {
            date: this.date,
            $limit: 500
          }
        }).then(bookings => {
//          this.loading = false

          this.allBookings = bookings.data
        }).catch(error => {
//          this.loading = false
          toastr.error('There was an error loading bookings, please try again!', 'Error')

          throw error
        })
      }, 50)

    },
    computed: {
      selectedPrice() {
        let price = 0

        const cost = this.selected.map((item) => {
          return item.cost
        })

        if (cost.length > 0) {
          price = cost.reduce((a, b) => { return a+b })
        }

//        for (let service of this.additionalServices) {
//          if (service.selected) {
//            if (service.priceType === 'perPerson') price = price + (this.details.numPeople || 0) * Number(service.price)
//            else price = price + Number(service.price);
//          }
//
//        }

        if (price === 0) return 0

        if (this.voucher && this.voucher.deduct.absolute) price = price - this.voucher.deduct.absolute
        if (this.voucher && this.voucher.deduct.percentage) price = (1 - this.voucher.deduct.percentage) * price

        return numeral(price).format('0,0.00')
      },
      canContinue() {
        if (this.step === 1) {
          if (this.selected.length > 0) return true
        } else if (this.step === 2) {
          return true
        } else if (this.step === 3) {
          return true
        }

        return false
      },
      canBack() {
        return this.step > 1
      },
      ruler() {
        if (this.date != moment().format('YYYY-MM-DD')) {
          return {
            'visible': false,
            'left': '0px'
          }
        }

//        console.log('calculating ruler...')

        let firstTime = moment().hours(10).minutes(0).seconds(0)
        let diffSeconds = moment(this.now).diff(firstTime, 'seconds')
        let left = 0

//        console.log(firstTime, diffSeconds)

        if (diffSeconds > 0 && diffSeconds <= 13 * 60 * 60) {
//          console.log(Math.round(this.rulerGeometry.leftOffset + (diffSeconds / (13 * 60 * 60)) * this.rulerGeometry.span))
          left = Math.round(this.rulerGeometry.leftOffset + (diffSeconds / (13 * 60 * 60)) * this.rulerGeometry.span)
        } else {
          return {
            'visible': false,
            'left': '0px'
          }
        }

        return {
          'visible': true,
          'left': left + 'px'
        }
      },
      boatsStartFull() {
        return this.boats.filter(b => !b.startsAtHalfHour)
      },
      boatsStartHalf() {
        return this.boats.filter(b => !!b.startsAtHalfHour)
      }
    },
    mounted() {
      this.fetchBoats()


      setInterval(() => {
        this.now = moment().format()
      }, 60 * 1000)

      this.setupClientId();
      this.setupTimeoutEvents();
      this.setUpEvents();

      this.loadSettings();

      if (this.$route.query.confirmed) {
        $('#emailConfirmModal').modal({
          onHide: function () {
            this.$router.push('/')
          }.bind(this)
        }).modal('show')
      }

      moment.locale('de')

      this.initUiFirstStep()

      setTimeout(() => {
        $('.ui.basic.calendar').calendar('focus')
      }, 300)

      this.getGeometry()
    },
    methods: {
      setupClientId() {
        let bookingClient = this.$cookie.get('booking-client')

        if (bookingClient) this.clientId = bookingClient

        app.io.on('connect', arg => {
          if (!bookingClient) {
            this.$cookie.set('booking-client', app.io.id)
            this.clientId = app.io.id
          }
          this.pushClientToSocket();
        })
      },
      setupTimeoutEvents() {
        services.sessionService.on('notifyTimeoutClient', data => {
          if (data.clientId != this.clientId) return

          if (this.selected.length > 0) $('#timeoutWarningModal').modal('show')
        })

        services.sessionService.on('timeoutClient', data => {
          if (data.clientId != this.clientId) return

          $('#timeoutWarningModal').modal('hide')
          this.selected = []
          this.step = 1
        })

        $('#timeoutWarningModal').modal({
            onHide: function () {
              this.resetSession()
            }.bind(this)
        })
      },
      setUpEvents() {
        services.bookingService.on('created', booking => {
          this.updatedBooking = booking
        })

        services.bookingService.on('patched', booking => {
          this.updatedBooking = booking
        })
      },
      initUiFirstStep() {
        const formatter = {
          date: (date, settings) => { return moment(date).format('dddd, LL') }
        }

        $('.huge.menu').visibility({
          type: 'fixed',
          offset: 0
        });

        $('.ui.basic.calendar').calendar({
          type: 'date',
          initialDate: new Date(),
          minDate: new Date('2026-01-01'),
          maxDate: new Date('2026-12-31'),
          formatter: formatter,
          text: {
            months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            today: 'Heute',
            now: 'Jetzt'
          },
          onChange: (date, text) => {
            this.date = moment(date).format('YYYY-MM-DD')
          }
        }).calendar('set date', this.date ? this.date : (moment().hour() >= 23 ? moment().add(1, 'days').toDate() : new Date()))

        $('.ui.dropdown').dropdown()
      },
      loadSettings() {
        services.settingService.find({
          $limit: 1,
          $sort: {_id: -1}
        }).then(settings => {
//          console.log(settings)
          if (settings.total > 0) this.settings = settings.data[0]
        })

        services.reasonService.find({}).then(reasons => {
          this.reasons = reasons.data
        })

        services.additonalServiceService.find({}).then(services => {
          this.additionalServices = services.data
        })
      },
      toggleService(service) {
        if (!('selected' in service)) service.selected = true
        else service.selected = !service.selected

        this.additionalServices.splice(this.additionalServices.findIndex((addService) => {return addService._id === service._id }), 1, service)
      },
      showBoatDescription(boat) {
        this.describeBoat = boat
        setTimeout(() => {
          $('#boatDescriptionModal').modal('refresh')
        }, 100)
        $('#boatDescriptionModal').modal('show')
      },
      fetchBoats() {
        services.boatService.find({query: { hidden: { $ne: true }, $sort: {'order': 1}}}).then((boats) => {
          this.boats = boats.data
        })
      },
      datePlus() {
        $('.ui.basic.calendar').calendar('set date', moment(this.date).add(1, 'd').format())
      },
      dateMinus() {
        $('.ui.basic.calendar').calendar('set date', moment(this.date).subtract(1, 'd').format())
      },
      selected(booking) {
        this.selected.push(booking)
      },
      pushClientToSocket() {
          app.io['clientId'] = this.clientId
      },
      confirmBooking() {
        if (this.submitting) return

        this.submitting = true

        let reservation = {
          'contact': this.contact,
          'parsedTel': this.contact.tel.replace(/[^1-9]/, ''),
          '_bookings': this.selected.map((booking) => {return booking._id}),
          'confirmed': true,
          'allBookings': this.selected,
          'wishes': this.details.wishes,
          'questions': this.details.questions,
          '_reason': this.details._reason,
          'reason': this.details.reason,
          'services': this.additionalServices.filter(service => {return service.selected}),
          'people': this.details.numPeople,
          'discount': this.voucher ? { 'absolute': this.voucher.deduct.absolute, 'percentage': this.voucher.deduct.percentage, 'voucher': this.voucher.code } : null,
          'clientId': this.clientId
        }

        services.reservationService.create(reservation).then((createdReservations) => {
          this.submitting = false

          this.createdReservation.code = createdReservations[0].code
          this.createdReservation.contact = createdReservations[0].contact
          this.createdReservation.bookings = reservation.allBookings
          this.createdReservation.people = createdReservations[0].people
          this.createdReservation.wishes = createdReservations[0].wishes
          this.createdReservation.questions = createdReservations[0].questions
          this.createdReservation.services = createdReservations[0].services
          this.createdReservation.reason = createdReservations[0].reason
          this.createdReservation.discount = createdReservations[0].discount
          this.createdReservation.cost = createdReservations[0].payment.toPay

          setTimeout(() => {
            $('#emailConfirmModal').modal('show')
            setTimeout(() => {
              $('#emailConfirmModal').modal('refresh')
            }, 300)
          }, 100)

          this.selected = []
          this.detailsFormValid = false
          this.formValid = false
          this.step = 1
          this.contact['firstName'] = null
          this.contact['lastName'] = null
          this.contact['email'] = null
          this.contact['company'] = null
          this.contact['title'] = null
          this.contact['terms'] = false
          this.contact['address'] = null
          this.contact['city'] = null
          this.contact['zip'] = null
          this.contact['tel'] = null
          this.details = {
            'numPeople': null,
            'voucher': null,
            'wishes': null,
            'questions': null,
            'reason': null,
            'services': []
          }
          for (let service of this.additionalServices) {
            service.selected = false
          }
        }).catch(error => {
          this.submitting = false

          toastr.error(error, 'Something went wrong!')

          throw error
        })
      },
      goToConfirm() {
        $('.ui.contact-details.form').form('validate form')
      },
      goToContactDetails() {
        $('.ui.details.form').form('validate form')
      },
      resetSession() {
        services.sessionService.patch(null, { lastAction: new Date() }, { query: { clientId: this.clientId } }).then((session) => {
//            $('#timeoutWarningModal').modal('hide')
        })
      },
      triggerCancelModal() {
          $('#cancelModal').modal('show')
      },
      beforeAnimationEnter(el) {
        if (this.step > this.animation.oldStep) {
          $(el).addClass('fadeInRight')
        } else {
          $(el).addClass('fadeInLeft')
        }
      },
      beforeAnimationLeave(el) {
        if (this.step > this.animation.oldStep) {
          $(el).addClass('fadeOutLeft')
        } else {
          $(el).addClass('fadeOutRight')
        }
      },
      getGeometry() {
        setTimeout(() => {
          let firstHourHeader = document.getElementById('firstHourHeader').getBoundingClientRect()
          let lastHourHeader = document.getElementById('lastHourHeader').getBoundingClientRect()
          let container = document.getElementById('segment').getBoundingClientRect()

          let offsetFirst = firstHourHeader.left - container.left
          let offsetLast = lastHourHeader.right - container.left

          this.rulerGeometry.span = offsetLast - offsetFirst
          this.rulerGeometry.leftOffset = offsetFirst
        }, 500)
      },
      printConfirmation() {
//        console.log('print conirmation')
        printJS({ printable: 'bookingConfirmation', type: 'html', font: 'Arial', documentTitle: 'buki_bestaetigung'  })
      }
    },
    components: {
        BookingChoice, CancelBooking, BookingConfirmation
    }
  }
</script>

<style scoped>
  .main.header {
    margin: 50px 0;
    margin-top: 50px !important;
  }
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }
  .calendar.item {
    padding: 4px 1px 0;
  }
  .boat-title {
    cursor: pointer;
  }
  .boat-title .title {
    color: #4183C4;
  }
  td.boat-title:hover {
    background: rgba(0,0,0,.1) !important;
  }
  tr.thick-border td {
    border-top: 2px solid rgba(0, 0, 0, 0.4);
  }
  .step-choice {
    border-right: 1px solid #989898;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 12px;
    color: #6d6d6d;
  }
  .step-choice:last-child {
    border-right: none;
  }
  .huge.menu.fixed {
    width: 1120px;
  }
  .huge.menu.placeholder {
    height: 43px;
  }
  .small.item {
    font-size: 14px;
  }
  .red.item {
    color: #771d14;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter {
    transform: translateX(100%);
    opacity: 0;
  }
  .slide-fade-enter-to {
    transform: translateX(0%);
    opacity: 1;
  }
  .slide-fade-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

  .service.list.item {
    display: flex;
    flex-flow: nowrap;
    border-bottom: 1px solid #eeeeee;
    padding: 8px 0;
  }
  .service.list.item .content {
    flex-grow: 1;
    margin-right: 10px;
  }
  .service.list.item .select {
    margin-right: 30px;
    min-width: 90px;
  }
  .service.list.item .price {
    font-size: 13px;
    padding-top: 6px;
    min-width: 100px;
  }
  .service.list.item .icon {
    margin: 0 10px;
    /*align-self: center;*/
  }
  span.strong {
    font-weight: bold;
    color: #934c38;
  }
  .calendar .huge.input {
    width: 325px;
  }
  .ruler span {
    position: absolute;
    top: -2px;
    left: -25px;
    width: 50px;
    height: 15px;
    line-height: 14px;
    background-color: red;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// Booking.vue?b035fd9c